import { ADD_SEARCH_BY_COMMUNITY_USER_EVALUATOR_INNOVATE_IDEA_FAILURE, ADD_SEARCH_BY_COMMUNITY_USER_EVALUATOR_INNOVATE_IDEA_STARTED, ADD_SEARCH_BY_COMMUNITY_USER_EVALUATOR_INNOVATE_IDEA_SUCCESS, ADD_USER_EVALUATOR_INNOVATE_IDEA_FAILURE, ADD_USER_EVALUATOR_INNOVATE_IDEA_STARTED, ADD_USER_EVALUATOR_INNOVATE_IDEA_SUCCESS, DELETE_IDEA_ASSIGNED_EVALUATOR_FAILURE, DELETE_IDEA_ASSIGNED_EVALUATOR_STARTED, DELETE_IDEA_ASSIGNED_EVALUATOR_SUCCESS, GET_JSON_EVALUATOR_RATED_INNOVATE_FAILURE, GET_JSON_EVALUATOR_RATED_INNOVATE_STARTED, GET_JSON_EVALUATOR_RATED_INNOVATE_SUCCESS, GET_LIST_EVALUATOR_ASSIGNED_INNOVATE_FAILURE, GET_LIST_EVALUATOR_ASSIGNED_INNOVATE_STARTED, GET_LIST_EVALUATOR_ASSIGNED_INNOVATE_SUCCESS, GET_USER_EVALUATOR_SEARCH_BY_COMMUNITY_INNOVATE_FAILURE, GET_USER_EVALUATOR_SEARCH_BY_COMMUNITY_INNOVATE_STARTED, GET_USER_EVALUATOR_SEARCH_BY_COMMUNITY_INNOVATE_SUCCESS, GET_USER_EVALUATOR_SEARCH_INNOVATE_FAILURE, GET_USER_EVALUATOR_SEARCH_INNOVATE_STARTED, GET_USER_EVALUATOR_SEARCH_INNOVATE_SUCCESS } from 'actions/sync/innovate/idea/Constants'
import * as types from 'actions/sync/evaluation/Constants'

export const initialState = {
  activeStep: 0,
  data: [],
  items: 0,
  total: 0,
  hasMore: true,
  dataArchived: [],
  itemsArchived: 0,
  totalArchived: 0,
  hasMoreArchived: true,
  dataPending: [],
  itemsPending: 0,
  totalPending: 0,
  hasMorePending: true,
  ideaevaluation: {
    id: '',
    statusType: '',
    roundClosed: '',
    ownerEmail: '',
    ideaTitle: '',
    ideaText: '',
    Q1Comment: '',
    Q1measurement: 0,
    Q2Comment: '',
    Q2measurement: 0,
    Q3Comment: '',
    Q3measurement: 0,
    type: '',
  },
  list: [],
  evaluationLoading: false,
  addEvaluatorListIsLoading:false,
  getListEvaluatorAssignedIdeaIsLoading:false,
  getJsonEvaluatorForRatingIsLoading:false,
  deleteAssignedEvaluatorIdeaIsLoading:false,
  addSearchByCommunityUserInnovateIdeaIsLoading:false,
  addSearchByCommunityUserInnovateIdea:[],
  getSearchByCommunityUserInnovateIdeaIsLoading:false,
  getSearchByCommunityUserInnovateIdea:[],
  deleteAssignedEvaluatorIdea:[],
  getJsonEvaluatorForRating:[],
  getListEvaluatorAssignedIdea:[],
  addEvaluatorList:[],
  userEvaluatorSuggestions:[],
}
const evaluationReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_EVALUATION_IDEA_STARTED:
      return {
        ...state,
        ideaevaluation: {},
        evaluationLoading: true,
      }
    case types.GET_EVALUATION_DRAFT_STARTED:
    case types.POST_EVALUATION_DRAFT_STARTED:
    case types.POST_EVALUATION_STATUS_STARTED:
      return {
        ...state,
        evaluationLoading: true,
      }
    case types.GET_EVALUATION_IDEA_SUCCESS: {
      const newItems = [...state.data, ...action.response.data]
      return {
        ...state,
        data: newItems,
        items: action.response.items,
        total: action.response.total,
        hasMore: newItems.length < action.response.total,
        evaluationLoading: false,
      }
    }
    case types.GET_EVALUATION_DRAFT_SUCCESS: {
      return {
        ...state,
        ideaevaluation: action.response.ideaevaluation,
        list: action.response.list,
        evaluationLoading: false,
      }
    }

    case types.POST_EVALUATION_DRAFT_SUCCESS:
    case types.POST_EVALUATION_STATUS_SUCCESS:
      return {
        ...state,
        evaluationLoading: false,
      }

    case types.GET_EVALUATION_DRAFT_FAILURE:
    case types.POST_EVALUATION_DRAFT_FAILURE:
    case types.POST_EVALUATION_STATUS_FAILURE:
      return {
        ...state,
        evaluationLoading: false,
      }

    case types.INCREASE_EVALUATION_STEP:
      return {
        ...state,
        activeStep: state.activeStep + 1,
      }

    case types.DECREASE_EVALUATION_STEP:
      return {
        ...state,
        activeStep: state.activeStep - 1,
      }

    // Evaluation Archived reducers
    case types.GET_EVALUATION_IDEA_PENDING_STARTED:
    case types.GET_EVALUATION_IDEA_ARCHIVED_STARTED:
      return {
        //initialState,
        ...state,
        evaluationLoading: true,
      }

    case types.GET_EVALUATION_IDEA_PENDING_SUCCESS: {
      const newItems = [...state.dataPending, ...action.response.dataPending]
      return {
        ...state,
        dataPending: newItems,
        itemsPending: action.response.itemsPending,
        totalPending: action.response.totalPending,
        hasMorePending: newItems.length < action.response.totalPending,
        evaluationLoading: false,
      }
    }
    case types.GET_EVALUATION_IDEA_ARCHIVED_SUCCESS: {
      const newItems = [...state.dataArchived, ...action.response.dataArchived]
      return {
        ...state,
        dataArchived: newItems,
        itemsArchived: action.response.itemsArchived,
        totalArchived: action.response.totalArchived,
        hasMoreArchived: newItems.length < action.response.totalArchived,
        evaluationLoading: false,
      }
    }

    case types.GET_EVALUATION_IDEA_ARCHIVED_FAILURE:
    case types.GET_EVALUATION_IDEA_PENDING_FAILURE:
      return {
        ...state,
        evaluationLoading: false,
      }
     
    case GET_USER_EVALUATOR_SEARCH_INNOVATE_STARTED:
      return{
        ...state,
        evaluationLoading: true,
      }  
    case GET_USER_EVALUATOR_SEARCH_INNOVATE_SUCCESS:
      return{
        ...state,
        userEvaluatorSuggestions:action.response,
        evaluationLoading: false,
      }  
    case GET_USER_EVALUATOR_SEARCH_INNOVATE_FAILURE:
      return{
        ...state,
        evaluationLoading: false,
    }
    case ADD_USER_EVALUATOR_INNOVATE_IDEA_STARTED:
      return{
        ...state,
        addEvaluatorListIsLoading:true,
      }  
    case ADD_USER_EVALUATOR_INNOVATE_IDEA_SUCCESS:
      return{
        ...state,
        addEvaluatorList:action.response,
        addEvaluatorListIsLoading:false,
      }  
    case ADD_USER_EVALUATOR_INNOVATE_IDEA_FAILURE:
      return{
        ...state,
        addEvaluatorListIsLoading:false,
      }  

    case GET_LIST_EVALUATOR_ASSIGNED_INNOVATE_STARTED:
      return{
        ...state,
        getListEvaluatorAssignedIdeaIsLoading:true
      }
    case GET_LIST_EVALUATOR_ASSIGNED_INNOVATE_SUCCESS:
      return{
        ...state,
        getListEvaluatorAssignedIdea:action.response,
        getListEvaluatorAssignedIdeaIsLoading:false
      }
    case GET_LIST_EVALUATOR_ASSIGNED_INNOVATE_FAILURE:
      return{
        ...state,
        getListEvaluatorAssignedIdeaIsLoading:false
      }
      

    case DELETE_IDEA_ASSIGNED_EVALUATOR_STARTED:
      return{
        ...state,
        deleteAssignedEvaluatorIdeaIsLoading:true
      }
    case DELETE_IDEA_ASSIGNED_EVALUATOR_SUCCESS:
      return{
        ...state,
        deleteAssignedEvaluatorIdea:action.response,
        deleteAssignedEvaluatorIdeaIsLoading:false
      }
    case DELETE_IDEA_ASSIGNED_EVALUATOR_FAILURE:
      return{
        ...state,
        deleteAssignedEvaluatorIdeaIsLoading:false
      }
      
    
    case GET_JSON_EVALUATOR_RATED_INNOVATE_STARTED:
      return{
        ...state,
        getJsonEvaluatorForRatingIsLoading:true
      }
    case GET_JSON_EVALUATOR_RATED_INNOVATE_SUCCESS:
      return{
        ...state,
        getJsonEvaluatorForRating:action.response,
        getJsonEvaluatorForRatingIsLoading:false
      }
    case GET_JSON_EVALUATOR_RATED_INNOVATE_FAILURE:
      return{
        ...state,
        getJsonEvaluatorForRatingIsLoading:false
      }
      
    
    case ADD_SEARCH_BY_COMMUNITY_USER_EVALUATOR_INNOVATE_IDEA_STARTED:
      return{
        ...state,
        addSearchByCommunityUserInnovateIdeaIsLoading:true
      }
    case ADD_SEARCH_BY_COMMUNITY_USER_EVALUATOR_INNOVATE_IDEA_SUCCESS:
      return{
        ...state,
        addSearchByCommunityUserInnovateIdea:action.response,
        addSearchByCommunityUserInnovateIdeaIsLoading:false
      }
    case ADD_SEARCH_BY_COMMUNITY_USER_EVALUATOR_INNOVATE_IDEA_FAILURE:
      return{
        ...state,
        addSearchByCommunityUserInnovateIdeaIsLoading:false
      }
      
      
    case GET_USER_EVALUATOR_SEARCH_BY_COMMUNITY_INNOVATE_STARTED:
      return{
        ...state,
        getSearchByCommunityUserInnovateIdeaIsLoading:true
      }
    case GET_USER_EVALUATOR_SEARCH_BY_COMMUNITY_INNOVATE_SUCCESS:
      return{
        ...state,
        getSearchByCommunityUserInnovateIdea:action.response,
        getSearchByCommunityUserInnovateIdeaIsLoading:false
      }
    case GET_USER_EVALUATOR_SEARCH_BY_COMMUNITY_INNOVATE_FAILURE:
      return{
        ...state,
        getSearchByCommunityUserInnovateIdeaIsLoading:false
      }
      
    case types.POST_ADMIN_USER_CREATE_STARTED:
      return{
        ...state,
        postAdminCreateUserIsLoading:true
      }
      case types.POST_ADMIN_USER_CREATE_SUCCESS:
      return{
        ...state,
        postAdminCreateUser:action.response,
        postAdminCreateUserIsLoading:false
      }
      case types.POST_ADMIN_USER_CREATE_FAILURE:
      return{
        ...state,
        postAdminCreateUserIsLoading:false
      }
      
      


    case types.SET_LOGEDOUT:
      return initialState
    default:
      return state
  }
}

export default evaluationReducer
